var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDocument = function SvgDocument(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 16.5a.5.5 0 0 1-.5-.5V4c0-.275.225-.5.5-.5h5V6c0 .553.447 1 1 1h2.5v9c0 .275-.225.5-.5.5zM6 2c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h8c1.103 0 2-.897 2-2V6.828a2 2 0 0 0-.584-1.416l-2.832-2.828A2 2 0 0 0 11.172 2zm1.75 8a.75.75 0 0 0-.75.75c0 .416.334.75.75.75h4.5c.416 0 .75-.334.75-.75a.75.75 0 0 0-.75-.75zm0 3a.75.75 0 0 0-.75.75c0 .416.334.75.75.75h4.5c.416 0 .75-.334.75-.75a.75.75 0 0 0-.75-.75z"
  })));
};
export default SvgDocument;